import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import {
  NotFound,
  Products,
  Users,
  CreateUser,
  EditUser,
  ProductForm,
  ListOfValues,
  Sidebar,
  CreateDatasheet,
  ProductsImport,
  BatchUpload,
} from 'pages';
import Navbar from './pages/Navbar';

const MainRoutes = (props) => {
  return (
    <Router>
      <Navbar />
      <Sidebar />
      <Switch>
        <Route
          exact
          path="/products-import"
          component={ProductsImport}
        />
        <Route exact path="/products/:bu?/:category?" component={Products} />
        <Route exact path="/upload" component={BatchUpload} />
        <Route exact path="/values" component={ListOfValues} />
        <Route exact path="/users" component={Users} />
        <Route exact path="/users/add" component={CreateUser} />
        <Route exact path="/users/:id/edit" component={EditUser} />
        <Route
          exact
          path="/products/:bu/:category/new"
          component={ProductForm}
        />
        <Route
          exact
          path="/products/:bu/:category/:productName/edit"
          component={ProductForm}
        />
        <Route
          exact
          path="/products/:bu/:category/by-sku/:productSku/edit"
          component={ProductForm}
        />
        <Route
          exact
          path="/products/:bu/:category/:productName/templates/:templateId/edit"
          component={CreateDatasheet}
        />
        <Route
          exact
          path="/products/:bu/:category/:productName/templates/:templateId"
          component={CreateDatasheet}
        />
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};

export default MainRoutes;
